//* Catálogo funnel v3.0 (espejo de api-rendafin CLIENT_EVENT_TYPES). label + icono PrimeIcons +
//* severidad para el chip de categoría en el timeline. El label NO viene del backend (los eventos
//* son del catálogo cerrado), a diferencia del label de ChannelSource que sí es administrable.
export interface ClientEventMeta {
  label: string
  icon: string
  severity: 'success' | 'info' | 'warning' | 'danger' | 'secondary' | 'contrast'
}

export const CLIENT_EVENT_LABELS: Record<string, ClientEventMeta> = {
  'client.created': { label: 'Cliente dado de alta', icon: 'pi pi-user-plus', severity: 'info' },
  'client.updated': { label: 'Datos del cliente actualizados', icon: 'pi pi-pencil', severity: 'secondary' },
  'client.login': { label: 'Inicio de sesión del cliente', icon: 'pi pi-sign-in', severity: 'secondary' },
  'channel.assigned': { label: 'Canal de origen asignado', icon: 'pi pi-sitemap', severity: 'info' },
  'channel.reassigned': { label: 'Canal de origen reasignado', icon: 'pi pi-sitemap', severity: 'warning' },
  'quotation.created': { label: 'Cotización creada', icon: 'pi pi-calculator', severity: 'info' },
  'quotation.status_changed': { label: 'Cotización cancelada', icon: 'pi pi-calculator', severity: 'warning' },
  'verification.started': { label: 'Verificación CIEC iniciada', icon: 'pi pi-shield', severity: 'info' },
  'verification.completed': { label: 'Verificación CIEC completada', icon: 'pi pi-verified', severity: 'success' },
  'verification.failed': { label: 'Verificación CIEC fallida', icon: 'pi pi-times-circle', severity: 'danger' },
  'document.uploaded': { label: 'Documento cargado', icon: 'pi pi-file', severity: 'secondary' },
  'document.approved': { label: 'Documento aprobado', icon: 'pi pi-check-circle', severity: 'success' },
  'document.rejected': { label: 'Documento rechazado', icon: 'pi pi-times-circle', severity: 'danger' },
  'funnel.activity.created': { label: 'Tarea de funnel creada', icon: 'pi pi-flag', severity: 'info' },
  'funnel.activity.state_changed': { label: 'Tarea de funnel actualizada', icon: 'pi pi-flag', severity: 'secondary' },
  'lease.created': { label: 'Arrendamiento iniciado (handoff)', icon: 'pi pi-briefcase', severity: 'success' },
  'client.won': { label: 'Cliente convertido (ganado)', icon: 'pi pi-check-circle', severity: 'success' },
  'client.lost': { label: 'Cliente caído (perdido)', icon: 'pi pi-ban', severity: 'danger' },
  'client.reactivated': { label: 'Cliente reactivado (nueva oportunidad)', icon: 'pi pi-replay', severity: 'info' },
  'client.deactivated': { label: 'Acceso al portal desactivado', icon: 'pi pi-lock', severity: 'danger' },
  'client.access_reactivated': { label: 'Acceso al portal reactivado', icon: 'pi pi-unlock', severity: 'success' },
  'client.deleted': { label: 'Cliente eliminado', icon: 'pi pi-trash', severity: 'danger' },
  'client.seller_reassigned': { label: 'Vendedor reasignado', icon: 'pi pi-user-edit', severity: 'warning' },
  'client.broker_reassigned': { label: 'Broker reasignado', icon: 'pi pi-user-edit', severity: 'warning' },
}

export function clientEventMeta(type: string): ClientEventMeta {
  return CLIENT_EVENT_LABELS[type] ?? { label: type, icon: 'pi pi-circle', severity: 'secondary' }
}

//* Opciones del multiselect de filtro por categoría del timeline. El value es el prefijo del tipo;
//* onFilterChange lo convierte en `${value}.*` para el typeIn (regex backend). 'client.*' ya cubre won/lost.
export const CLIENT_EVENT_CATEGORY_OPTIONS = [
  { value: 'client', label: 'Cliente' },
  { value: 'channel', label: 'Canal' },
  { value: 'verification', label: 'Verificación CIEC' },
  { value: 'quotation', label: 'Cotización' },
  { value: 'document', label: 'Documentos' },
  { value: 'funnel', label: 'Tareas de funnel' },
  { value: 'lease', label: 'Arrendamiento' },
]

//* Causas de caída (espejo de LOSS_REASONS del backend) para el modal de cierre.
export const LOSS_REASON_LABELS: Record<string, string> = {
  client_choice: 'El cliente eligió otra opción',
  budget_insufficient: 'Presupuesto insuficiente',
  ciec_required: 'No completó la CIEC',
  docs_incomplete: 'Documentación incompleta',
  committee_rejected: 'Rechazado en Comité',
  payment_failed: 'Falló el pago inicial',
  other: 'Otro',
}

export const LOSS_REASON_OPTIONS = Object.entries(LOSS_REASON_LABELS).map(([value, label]) => ({ value, label }))
